import { render, staticRenderFns } from "./NewSkillDialog.vue?vue&type=template&id=785623b4"
import script from "./NewSkillDialog.vue?vue&type=script&lang=js"
export * from "./NewSkillDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports